import {
  createFamily as createFamilyApi
  , getRecentFamilies as getRecentFamiliesApi
  , getFamilyById as getFamilyByIdApi
  , updateFamily as updateFamilyApi
  , updateFamilyAddress as updateFamilyAddressApi
  , activateFamily as activateFamilyApi
} from "./SpatApi";
import { showErrorToast, showSuccessToast } from "../utils/Toasts";

// Fetch recent families
export async function fetchRecentFamilies(setRecentFamilies, setLoading, setErrorMessage, status) {
  setLoading(true); // Set loading state to true while fetching
  try {
    const response = await getRecentFamiliesApi(status);
    if (response?.status === 200) {
      setRecentFamilies(response.data.familyList); // Set fetched families
    } else {
      showErrorToast(response?.data?.message || response?.message || "Failed to fetch recent families");
      setErrorMessage(response?.data?.message || response?.message || "Failed to fetch recent families");
    }
  } catch (error) {
    showErrorToast("Error fetching recent families.");
    setErrorMessage("Error fetching recent families.");
  } finally {
    setLoading(false); // Set loading state to false after fetching
  }
}

// Create a new family
export async function handleCreateFamily(data) {
  try {
    const response = await createFamilyApi(data);
    if (response?.status === 201 || response?.status === 200) {
      showSuccessToast(response?.data?.message || "Family created successfully.");
      return response?.data?.familyId;
    } else {
      showErrorToast(response?.data?.message || response?.message || "Something went wrong while creating family.");
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "Something went wrong while creating family");
    return false;
  }
}

// Fetch family by ID
export async function fetchFamilyById(familyId) {
  try {
    const response = await getFamilyByIdApi(familyId);
    if (response?.status === 200) {
      return response.data;
    } else {
      showErrorToast(response?.data?.message || response?.message || "Failed to fetch family data");
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "Error fetching family details");
    return false;
  }
}


// Update family details
export async function updateFamily(updatedFamilyData) {
  try {
    const response = await updateFamilyApi(updatedFamilyData);
    if (response?.status === 200 || response?.status === 201) {
      showSuccessToast("Family updated successfully");
      return true; // Return true on success
    } else {
      showErrorToast(response?.data?.message || response?.message || "Something went wrong while updating family");
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "Error updating family");
    return false;
  }
}

// Update family address
export async function updateFamilyAddress(data) {
  try {
    const response = await updateFamilyAddressApi(data);
    if (response?.status === 201 || response?.status === 200) {
      showSuccessToast(response?.data?.message || "Family address updated successfully.");
      return true; // Return true on success
    } else {
      showErrorToast(response?.data?.message || response?.message || "Something went wrong while updating family");
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "Something went wrong while updating family address.");
    return false;
  }
}

// Activate Pending family 
export async function activateFamily(data) {
  try {
    const response = await activateFamilyApi(data);
    if (response?.status === 201 || response?.status === 200) {
      showSuccessToast(response?.data?.message || "Family  activated successfully.");
      return response.data; // Return true on success
    } else {
      showErrorToast(response?.data?.message || response?.message || "Something went wrong while activating family");
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "Something went wrong while activating family .");
    return false;
  }
}